export const ValueTypes = {
  percent: "percent",
  currency: "currency",
  integer: "integer"
};
